import React, { ReactElement, ChangeEvent } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select, { Props as SelectProps } from 'components/@common/Inputs/Select';

export interface DropdownOption {
  label: string | ReactElement;
  value: any;
}

export type Props = SelectProps & {
  options: DropdownOption[];
  value: string | number;
  label: string | ReactElement;
  placeholder?: string;
  id: string;
  handleChange: (event: ChangeEvent<any>) => void;
};

const Dropdown = ({
  id,
  label,
  placeholder,
  handleChange,
  value,
  options,
  ...selectProps
}: Props) => {
  return (
    <Select
      label={label}
      placeholder={placeholder ?? `${label}`}
      id={`${id}-select`}
      value={value}
      onChange={handleChange}
      {...selectProps}
    >
      {options.map(
        (option: DropdownOption, key: number): ReactElement => (
          <MenuItem key={`${key}-dropdown-${id}-item`} value={option.value}>
            {option.label}
          </MenuItem>
        )
      )}
    </Select>
  );
};

export default Dropdown;
